<template>
  <input
    v-if="!item.is_field"
    v-model="templateStore.layers[layerIndex].items[itemIndex].value"
    class="BaseTemplateContentText transition"
    :style="dynamicStyles"
    v-bind="$attrs"
    @click="templateStore.handleActiveItem(item)"
  />
  <input
    v-else
    class="BaseTemplateContentText transition"
    :style="dynamicStyles"
    :readonly="true"
    :value="item.value && !hasPrinter ? `[${item.value.title}]` : item.value && hasPrinter ? item.value.title : ''"
    v-bind="$attrs"
    @click="templateStore.handleActiveItem(item)"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useTemplateStore } from 'src/stores'

defineOptions({ name: 'BaseTemplateContentText', inheritAttrs: false })
const props = defineProps({
  item: { type: Object, required: true },
  layerIndex: { type: Number, required: true },
  itemIndex: { type: Number, required: true },
  hasPrinter: { type: Boolean, default: false },
})

const templateStore = useTemplateStore()

const dynamicStyles = computed(
  () =>
    `width: ${props.item.width}px; height: ${props.item.height}px; font-size: ${props.item.font_size}px; font-weight: ${props.item.font_weight}; text-align: ${props.item.text_align}; color: ${props.item.colour}; font-family: ${props.item.font_family}`,
)
</script>
